export default __webpack_public_path__ + "static/media/dr-alejandro-curez-rounded.3b2da7a4.png";